import {Component, ViewContainerRef} from '@angular/core';
import {ToastsManager} from 'ng2-toastr';
import {Router} from '@angular/router';
import {AuthenticationService} from './_services/authentication.service';
import { OidcService } from './auth/oidc.service';
import { Log } from 'ng2-logger';

const log = Log.create("AppComponent");

@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {

  constructor(private toast: ToastsManager,
              private viewRef: ViewContainerRef,
              private oidcService: OidcService,
              private authenticationService: AuthenticationService,
              private router: Router) {
    log.info("Initializing...");
    toast.setRootViewContainerRef(viewRef);

    if (this.handleLoginRedirect()) {
      return;
    }

    const url = window.location.href;
    if (url.includes("/login") ||
        url.includes("/oidc")) {
      router.initialNavigation();
    } else {
      log.info("Redirecting by default...")
      oidcService.getUserOnce().subscribe(() => {
        authenticationService.getRedirectAfterLogin().subscribe((url) => {
          if (url) {
            log.info(`Redirecting to ${url}`);
            router.navigate(url);
          } else {
            router.navigate(['/']);
          }
        })
      });
    }
  }

  /**
   * Redirects to the oidc callback handlers based on the contents of the URL parameters.
   *
   * @returns true if there was a redirect
   */
  handleLoginRedirect(): boolean {
    // Handle OIDC callbacks

    // The following is a workaround to redirect to the correct callback handling pages,
    // since the OpenID provider does not let us use # in redirect URLs.

    // Gather all parameters, and make sure we don't have a trailing `#/`, which is added
    // automatically by the router.
    let searchParams: any = new URL(window.location.href.replace("#/", ""))
      .searchParams;
    if (searchParams.size > 0) {
      // These are the parameters we use to trigger the redirection to other pages. If
      // we find one of these then we need to switch to the relevant handler.
      let redirectionParams = ["oidc-authenticate", "oidc-silent"];

      // This is the list of actual meaningful parameters we must pass to the handling
      // route. We build this list by removing the redirection params from all params.
      let meaningfulParams = {};
      searchParams.forEach((value, param) => {
        if (!redirectionParams.includes(param)) {
          meaningfulParams[param] = value;
        }
      });

      if (searchParams.has("oidc-authenticate")) {
        // Correct the URL which typically contains the hash at the end. If we don't do
        // this the router will simply use everything as a base and append our query
        // to the front of the `#/`
        window.history.replaceState({}, "", new URL("#/", window.location.origin).toString());
        log.info("Redirecting: /oidc-authenticate");
        this.router.navigate(['/oidc-authenticate'], {
          queryParams: meaningfulParams,
        });
        return true;
      }

      if (searchParams.has("oidc-silent")) {
        window.history.replaceState({}, "", new URL("#/", window.location.origin).toString());
        log.info("Redirecting: /oidc-silent");
        this.router.navigate(['/oidc-silent'], {
          queryParams: meaningfulParams,
        });
        return true;
      }
    }

    console.log("Processing logged in user...");
    this.oidcService.processUser();
    return false;
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts